export default __webpack_public_path__ + "static/media/EyeOpen.f1e5a8ae.svg";